import { VoucherGenerator } from 'components/voucher/voucher-generator/VoucherGenerator'
import { useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { useFetch } from 'services/useFetch'
import { API_VOUCHER } from 'services/apiVoucher'
import { constructOptionsSelect, convertErrorMessage } from 'utils/utils'
import { Alert } from 'avo-ui'
import { useNavigate } from 'react-router-dom'
import { INITIAL_GENERATOR, INITIAL_STATE, GET_FIELD_NAME } from 'configs/voucher/configFormVoucherGenerator'
import { DUPLICATE_VALIDATION, GENERATOR_VALIDATION } from 'services/validation/voucherGeneratorValidation'

export const VoucherGeneratorContainer = () => {
    const navigate = useNavigate()
    const [generatorDetail, setGeneratorDetail] = useState(INITIAL_GENERATOR)
    const [duplicateDetail, setDuplicateDetail] = useState(INITIAL_STATE)
    const [voucherOptions, setVoucherOptions] = useState([])
    const { fetching: voucherCodeList } = useFetch(API_VOUCHER.LIST_CODE)
    const { fetching: duplicateVoucher, isLoading } = useFetch(API_VOUCHER.DUPLICATE_VOUCHER)
    const [errorMessage, setErrorMessage] = useState({})
    const { validateForm: validateGenerator, errorForm: errorGenerator } = useValidation({
        form: generatorDetail,
        schema: GENERATOR_VALIDATION,
    })
    const { validateForm: validateDuplicate, errorForm: errorDuplicate } = useValidation({
        form: duplicateDetail,
        schema: DUPLICATE_VALIDATION,
    })

    const GenerateVoucher = (amount, total, prefix) => {
        const result = []
        const characters = [
            'ABCDEFGHIJKLMNOPQRSTUVWXYZ', //uppercase
            'abcdefghijklmnopqrstuvwxyz', //lowercase
            '0123456789', //number
        ]
        for (let i = 0; i < total; i++) {
            let voucherName = prefix
            let index = 0
            for (let j = 0; j < amount; j++) {
                voucherName += characters[index]?.charAt(Math.floor(Math.random() * characters[index].length))
                if (index < characters.length - 1) {
                    index += 1
                } else {
                    index = 0
                }
            }
            result.push(voucherName)
        }
        return result
    }

    const onChangeGenerator = (item) => {
        setGeneratorDetail({ ...generatorDetail, ...item })
    }

    const onChangeForm = (item) => {
        setDuplicateDetail({ ...duplicateDetail, ...item })
    }

    const onSearchVoucher = (keyword) => {
        voucherCodeList({ search: keyword }).then((response) => {
            setVoucherOptions(constructOptionsSelect(response?.data, 'code', 'code'))
        })
    }

    const onGenerate = () => {
        validateGenerator().then(() => {
            const voucherCodes = GenerateVoucher(
                generatorDetail?.character_amount,
                generatorDetail?.total,
                generatorDetail?.prefix || '',
            )
            onChangeForm({ new_code: voucherCodes?.join(', ') })
        })
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateDuplicate().then(() => {
            const trimCode = duplicateDetail?.new_code?.replace(/\s/g, '')
            const payload = {
                new_code: trimCode?.split(','),
                target_code: duplicateDetail?.target_code?.value,
            }

            duplicateVoucher(payload)
                .then(() => {
                    navigate('/voucher/voucher-list')
                    return Alert({
                        icon: 'success',
                        title: 'Success',
                        message: 'Voucher Duplicated',
                    })
                })
                .catch((error) => setErrorMessage(convertErrorMessage(error?.data, GET_FIELD_NAME)))
        })
    }

    const props = {
        generatorDetail,
        onChangeGenerator,
        onGenerate,
        errorGenerator,
        duplicateDetail,
        voucherOptions,
        onSearchVoucher,
        onChangeForm,
        errorForm: { ...errorDuplicate, ...errorMessage },
        isLoading,
        onSubmit,
    }

    return <VoucherGenerator {...props} />
}
